import {makeKey,update} from '../../../../utils/reducerOperations';
export function deleteSurveyStarted(state, payload) {
    return makeKey(
        'deleteSurveyApi',
        update(state.deleteSurveyApi, {
            isProcessing: true,
            projectId: payload.projectId
        })
    );
}